/** @jsxImportSource @emotion/react */
import React, { useState } from 'react';

import { FormControl, InputLabel, Select } from 'src/common/ui/components';
import {
  formControlStyles,
  inputStyles,
  errorStyles,
} from 'src/components/pages/providers/Provider.Form.styles';

export type SelectOption = { value: string; label: string };

export const SelectInput = ({
  label,
  name,
  value,
  onChange,
  options,
  required = false,
  error,
}: {
  label: string;
  name: string;
  value: SelectOption | null;
  onChange: (option: SelectOption | null) => void;
  options: readonly SelectOption[] | SelectOption[];
  required?: boolean;
  error?: string;
}) => {
  const [touched, setTouched] = useState(false);
  const touchedAndError = touched && !!error;

  return (
    <FormControl css={formControlStyles} required={required} error={touchedAndError}>
      <InputLabel htmlFor={name}>{label}</InputLabel>
      <Select
        id={name}
        css={inputStyles}
        error={touchedAndError}
        value={value}
        onBlur={() => !touched && setTouched(true)}
        onChange={(_event, option) => onChange(option)}
        options={options}
      />
      {touchedAndError && <div css={errorStyles}>{error}</div>}
    </FormControl>
  );
};
